module.exports = __webpack_public_path__ + "img/single-shoe.5ef0a0db.svg";